import React from 'react';
import { ListColumnType, ListFilterFieldType, ListMoreMenuConfig } from 'types/ListTypes';
import { BulkActionsConfig } from 'types/BulkActionTypes';
import AbstractList from 'components/lists/AbstractList';
import AssetForm from './AssetForm';

// Enable the bulk actions panel for this list
const assetBulkActions: BulkActionsConfig = {
    objectKey: 'asset',
    deleteOrDeactivate: 'delete',
    showExport: true,
};

// Configure the more menu of this list
const assetMoreMenu: ListMoreMenuConfig = {
    inactiveItemsToggle: {
        semantic: 'deleted',
        activeParams: { deleted: true },
    },
};

// Set the filter fields of this list
const assetFilterFields: ListFilterFieldType[] = [
    {
        type: 'search',
        name: 'search',
        label: 'forms.search_label',
        placeholder: 'forms.search_placeholder',
        queryParam: 'search',
        width: 1.5
    },
    {
        type: 'dropdown',
        name: 'asset_type',
        label: 'asset.general.asset_type_label',
        queryParam: 'asset_type',
        apiRequest: {
            endpoint: 'get_asset_type_list',
            params: { deleted: false },
            object: 'asset_type'
        },
        width: 1.25
    }
];

// Rename the name of the function:
const AssetList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_asset_list',
        defaultParams: { 'deleted': false },
        object: 'asset'
    }
    const objectName = 'asset.general.object_name'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = true

    // Specify form, detail modal or detailpage for this list
    const formModal = <AssetForm />;
    const modalSize = 'add-form';
    const onRowClick = 'detailPage'
    const detailPageUrl = 'contacts/assets'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '2fr', field: 'name', label: 'asset.general.name_label' },
        { width: '1fr', field: 'asset_type_name', label: 'asset.general.asset_type_label' },
        { width: '3fr', field: 'location_address', label: 'asset.general.location_address_label' },
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            filterFields={assetFilterFields}
            formModal={formModal}
            modalSize={modalSize}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
            bulkActions={assetBulkActions}
            moreMenu={assetMoreMenu}
        />
    );
};

export default AssetList;